import MapMapbox from './mapMapbox';
import MapOl from './mapOl';

export default process.env.REACT_APP_MAP_ENGINE === 'mapbox' ? MapMapbox : MapOl;